import { render, staticRenderFns } from "./resumeDetails2.vue?vue&type=template&id=19028441&scoped=true&"
import script from "./resumeDetails2.vue?vue&type=script&lang=js&"
export * from "./resumeDetails2.vue?vue&type=script&lang=js&"
import style0 from "./resumeDetails2.vue?vue&type=style&index=0&id=19028441&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19028441",
  null
  
)

export default component.exports